(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["everystock-resellers"] && !Shopify.designMode) return;
  try {
    
(() => {
 const dialog=document.getElementById('ev-reseller-dialog');
 if(!dialog||typeof dialog.showModal!=='function')return;
 const key='ev-reseller-welcome-v1';
 let previousOverflow='';
 const open=()=>{if(dialog.open)return;previousOverflow=document.documentElement.style.overflow;dialog.showModal();document.documentElement.style.overflow='hidden';};
 dialog.addEventListener('close',()=>{document.documentElement.style.overflow=previousOverflow;try{sessionStorage.setItem(key,'seen')}catch{}});
 dialog.querySelectorAll('[data-reseller-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
 document.querySelectorAll('[data-reseller-open]').forEach(button=>button.addEventListener('click',open));
 dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();});
 let seen=false;try{seen=sessionStorage.getItem(key)==='seen'}catch{}
 if(!seen)open();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
